var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import useVirtual from 'react-cool-virtual';
import { createSelector } from '@reduxjs/toolkit';
import { store, useAppSelector } from '../../../store';
import { chatMessagesSelector } from '../../../store/slices/chatMessagesSlice';
import Message from './message';
const isActiveChatPanelSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveChatPanel);
$RefreshReg$(_react_refresh_temp_1, "isActiveChatPanelSelector$createSelector");
const Messages = ({ userId }) => {
    _react_refresh_temp_3();
    const allMessages = useAppSelector(chatMessagesSelector.selectAll);
    const isActiveChatPanel = useAppSelector(isActiveChatPanelSelector);
    const scrollToRef = useRef(null);
    const currentUser = store.getState().session.currentUser;
    const [chatMessages, setChatMessages] = useState([]);
    const [autoScrollToBottom, setAutoScrollToBottom] = useState(true);
    const { outerRef, innerRef, items, scrollToItem } = useVirtual({
        itemCount: chatMessages.length,
        onScroll: (event) => {
            if (event.visibleStopIndex === chatMessages.length - 1) {
                setAutoScrollToBottom(true);
            }
            else {
                setAutoScrollToBottom(false);
            }
        },
    });
    useEffect(() => {
        let chatMessages = [];
        if (userId === 'public') {
            chatMessages = allMessages.filter((m) => !m.isPrivate);
        }
        else {
            chatMessages = allMessages.filter((m) => m.isPrivate && (m.from.userId === userId || m.to === userId));
        }
        setChatMessages(chatMessages);
    }, [allMessages, userId]);
    const scrollToBottom = () => {
        if (!chatMessages.length || !autoScrollToBottom) {
            return;
        }
        if (scrollToRef.current) {
            scrollToItem({
                index: chatMessages.length - 1,
                smooth: true,
            }, () => {
                if (scrollToRef.current) {
                    scrollToRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'end',
                        inline: 'nearest',
                    });
                }
            });
        }
    };
    useEffect(() => {
        const timeout = setTimeout(() => {
            scrollToBottom();
        }, 500);
        return () => {
            clearTimeout(timeout);
        };
    }, [chatMessages.length]);
    // if we don't do this then scrolling won't go to bottom
    useEffect(() => {
        if (isActiveChatPanel) {
            setTimeout(() => {
                scrollToBottom();
            }, 500);
        }
    }, [isActiveChatPanel]);
    const renderMsg = (index) => {
        if (!chatMessages.length || typeof chatMessages[index] === 'undefined') {
            return null;
        }
        const body = chatMessages[index];
        return (_jsx(Message, { body: body, currentUser: currentUser }, body.message_id));
    };
    return (_jsx("div", { className: "relative h-full px-2 xl:px-4 pt-2 xl:pt-4 overflow-auto scrollBar scrollBar4 messages-item-wrap", ref: outerRef, children: _jsxs("div", { ref: innerRef, className: "inner", children: [items.map(({ index, measureRef }) => (_jsx("div", { ref: measureRef, className: "message-item mb-2 xl:mb-3", children: renderMsg(index) }, index))), _jsx("div", { ref: scrollToRef })] }) }));
};
_react_refresh_temp_2 = Messages;
$RefreshReg$(_react_refresh_temp_2, "Messages");
_react_refresh_temp_3(Messages, "e/vPBfnKjI8Gowy9I+tSpBdJyos=", false, () => [useAppSelector, useAppSelector, useVirtual]);
export default Messages;
